export enum TypesPriceList {
  GET_PRICE_LIST_REQUEST = 'user.GET_PRICE_LIST_REQUEST',
  GET_PRICE_LIST_SUCCESS = 'user.GET_PRICE_LIST_SUCCESS',
  GET_PRICE_LIST_ERROR = 'user.GET_PRICE_LIST_ERROR',
}
